import script from "./NewsfeedSearchModal.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsfeedSearchModal.vue?vue&type=script&setup=true&lang=js"

import "./NewsfeedSearchModal.vue?vue&type=style&index=0&id=a823c5fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a823c5fa"]])

export default __exports__